import { LockItem } from "../components/LockItem";
import { useLock } from "../hooks/useGetLockRecords";

const LockRecords: React.FC<{ onWithdraw: (startTs: number) => Promise<void> }> = ({ onWithdraw }) => {
  const { records } = useLock();
  return <>{records && records?.length > 0 && records?.map(record =>
    <LockItem
      key={record.startTs}
      record={record}
      onWithdraw={onWithdraw} />
  )}</>
}

export default LockRecords;